import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { config } from '../../ts/config';
import { IGlob } from '../../ts/Glob';
import SettingsImport, { ISettingsImportValue } from './AppSettingsImport';
import { ITableValue } from '../../../../_common/platform/tsx/tableSelect/Table';

export interface ITemplatesImport extends ISettingsImportValue {
    dirid?;
}

export default function TemplatesImport(props: {
    value: ITemplatesImport;
    input: string[];
    importFileName: string;
    glob: IGlob;

    onChange(value: ITemplatesImport): void;
}) {
    const [dirId, setDirId] = React.useState(props.value?.dirid);

    const selectFolderDef = React.useRef<JQuery.Deferred<any, any>>(null);

    const getValuesHash = React.useCallback(() => {
        return _.reduce(
            props.input,
            (hash, obj, i) => {
                hash[i] = obj; //{name: obj, data: {}};  //
                return hash;
            },
            {}
        );
    }, [props.input]);

    const passChange = React.useCallback((checkedList: ITableValue, dirid, valuesHash?) => {
        if (typeof props.onChange === 'function') {
            if (valuesHash === undefined) {
                valuesHash = getValuesHash();
            }

            const keyList = _.chain(checkedList)
                .map((value, key) => {
                    return valuesHash[key];
                })
                .compact()
                .value();

            props.onChange({
                keyList: keyList,
                dirid: dirid,
                checkedList: checkedList
            });
        }
    }, []);

    React.useEffect(() => {
        if (props.value == null) {
            passChange(props.value?.checkedList, dirId);
        }

        return () => {
            if (selectFolderDef.current != null) {
                selectFolderDef.current.reject();
                selectFolderDef.current = null;
            }
        };
    }, [props.value?.checkedList, dirId]);

    const handleOnFolderChange = (id) => {
        passChange(props.value?.checkedList, id);
        setDirId(id);
    };

    const getPath = (id, dataDefault) => {
        if (dataDefault == null || dataDefault.data == null) {
            return [];
        }

        let obj = dataDefault.data.dirsHash[id];

        const arr = [];

        while (obj != null) {
            arr.unshift(obj.name);
            obj = obj.parent;
        }

        return arr;
    };

    const handleOnFolderSelect = () => {
        const def = $.Deferred();

        props.glob.DialogActions.createDialog(
            'Select destination folder for imported widget',
            '',
            function (dirid) {
                def.resolve(dirid);
            },
            function () {
                def.reject();
            },
            function () {
                def.reject();
            },
            'templateDirSelect',
            {
                selectTitle: 'OK',
                rootId: config.TEMPLATES_ROOT_DIR_ID,
                overwriteShow: false,
                allowSelectItem: false
            }
        );

        def.done((id) => {
            handleOnFolderChange(id);
        });

        if (selectFolderDef.current != null) {
            selectFolderDef.current.reject();
        }

        selectFolderDef.current = def;
    };

    const handleOnFolderRemove = () => {
        handleOnFolderChange(null);
        handleOnFolderSelect();
    };

    const getOnSettingsChangeHandler = (valuesHash) => {
        return (obj: ISettingsImportValue) => {
            passChange(obj.checkedList, dirId, valuesHash);
        };
    };

    const dataDefault = props.glob.DirsStore._state.data['defaultTemplates'];

    let folderSelectButton: React.JSX.Element;

    if (dirId != null && dataDefault != null && dataDefault.data != null) {
        folderSelectButton = (
            <div className="btn btn-default">
                <span className="glyphicon glyphicon-remove" onClick={handleOnFolderRemove}></span>
                {'\\' + getPath(dirId, dataDefault).join('\\')}
            </div>
        );
    } else {
        folderSelectButton = (
            <div className="btn btn-default" onClick={handleOnFolderSelect}>
                <span>{'Select Target Folder'}</span>
            </div>
        );
    }

    const valuesHash = getValuesHash();

    return (
        <div className="templates-import">
            <div className="target-folder-select">{folderSelectButton}</div>

            <div className="table-container">
                <SettingsImport
                    value={props.value}
                    input={props.input}
                    valuesHash={valuesHash}
                    useFullTable={true}
                    glob={props.glob}
                    onChange={getOnSettingsChangeHandler(valuesHash)}
                />
            </div>
        </div>
    );
}
